<script>
    import { Toast } from 'sveltestrap';
    import { navigate } from 'svelte-routing';

    export let title = "";
    export let content = ""; 
    export let navigateLabel = "";
    export let isOpen = false; 
    export let navigateString = ""; 

</script>

<style>
   .navigate-text {
        color: #0267B3;
   }

   .navigate-text:hover {
        text-decoration: underline;
        cursor: pointer;
   }

   /* Global toast message styling */ 
    :global(.aim-toast) {
        position: fixed;
        top: 7px; 
        right: 7px;
        z-index: 1035; 
    }

    :global(.toast-header) {
        background-color: #3d5980;
        color: #FFFFFF;
        font-family: Poppins;
        font-weight: 100;
        min-width: 300px;
    }

    :global(.toast-body) {
        background-color: #FFFFFF;
    }
</style>        

<Toast
    class="aim-toast"
    body
    header="{title}"
    {isOpen}
    autohide
    on:close={() => (isOpen = false)}>
    <span> 
        {content}{#if navigateLabel}<span class="navigate-text" on:keydown on:click="{() => {navigate(navigateString)}}">{navigateLabel}</span>{/if}.
    </span>
</Toast>


